import { datadogRum } from "@datadog/browser-rum";
import { isEmpty } from "lodash";
import { setLevel } from "loglevel";
import type { LogLevelDesc } from "loglevel";
import React from "react";
import { onCLS, onINP, onLCP } from "web-vitals/attribution";

import { recordCLS, recordINP, recordLCP } from "core/telemetry/webVitals";
import envs from "env";
import { getGlobalConfigs } from "legacy/configs";
import localStorage from "legacy/utils/localStorage";
import { isDev } from "utils/env";

datadogRum.init({
  applicationId: envs.get("SUPERBLOCKS_UI_DATADOG_APPLICATION_ID"),
  clientToken: envs.get("SUPERBLOCKS_UI_DATADOG_CLIENT_TOKEN"),
  site: envs.get("SUPERBLOCKS_UI_DATADOG_SITE"),
  service: "superblocks-browser",
  env: envs.get("SUPERBLOCKS_UI_ENV"),
  version: envs.get("SUPERBLOCKS_UI_VERSION"),
  proxy: isEmpty(envs.get("SUPERBLOCKS_UI_DATADOG_PROXY_URL"))
    ? null
    : envs.get("SUPERBLOCKS_UI_DATADOG_PROXY_URL"),
  sessionSampleRate: Number(envs.get("SUPERBLOCKS_UI_DATADOG_RUM_SAMPLE_RATE")),
  startSessionReplayRecordingManually: true,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  // This is used to track the user's session across multiple domains, including iframe
  // must match logger setting
  useCrossSiteSessionCookie: true,
  allowedTracingUrls: [
    "https://app.superblockshq.com",
    "https://staging.superblockshq.com",
    "https://app.superblocks.com",
    "https://staging.superblocks.com",
    "https://eu.superblocks.com",
    "https://api.staging.superblocks.com",
    "https://api.superblocks.com",
  ],
});
// This metric is not yet supported by the RUM SDK
onINP(
  (metric) => {
    recordINP(metric.value);
    return datadogRum.addAction("web-vitals.onINP", {
      ...metric,
      duration: metric.value,
    });
  },
  {
    reportAllChanges: true,
  },
);
onLCP(
  (metric) => {
    recordLCP(metric.value);
  },
  {
    reportAllChanges: true,
  },
);
onCLS(
  (metric) => {
    recordCLS(metric.value);
  },
  {
    reportAllChanges: true,
  },
);

// Enable Why Did You Render? only in ?sb_wdyr=true mode
if (isDev() && window.location.search.includes("sb_wdyr=true")) {
  const whyDidYouRender = require("@welldone-software/why-did-you-render");
  whyDidYouRender(React, {
    trackAllPureComponents: true,
    trackExtraHooks: [["useSelector"]],
    titleColor: "white",
    diffNameColor: "white",
    diffPathColor: "red",
  });
}

const superblocksConfigs = getGlobalConfigs();

const getEnvLogLevel = (configLevel: LogLevelDesc): LogLevelDesc => {
  let logLevel = configLevel;
  if (localStorage && localStorage.getItem) {
    const localStorageLevel = localStorage.getItem("logLevel") as LogLevelDesc;
    if (localStorageLevel) logLevel = localStorageLevel;
  }
  return logLevel;
};

setLevel(getEnvLogLevel(superblocksConfigs.logLevel));
